import * as yup from 'yup';

import { Model as UserModel } from 'models/user/interface';
import { endpoint, EndpointError } from 'endpoints/endpoint';
import { USER_ROLES } from 'constants/index';

import { ValidationShape, ERROR } from '../validation';
import * as Pagination from '../pagination';

type Filter = {
  role: USER_ROLES;
};

export type PaginateParams = Pagination.Params<Omit<UserModel, 'uid'>, Filter>;

export type PaginateResult = {
  items: Array<UserModel>;
  page: number;
  pageSize: number;
  totalPages: number;
};
export type PaginateError = EndpointError;

export const paginationParamsSchema = yup.object().shape({
  role: yup.string().oneOf([USER_ROLES.ADMIN, USER_ROLES.HOST, USER_ROLES.SPEAKER]),
  page: yup.number().positive(ERROR.INVALID_VALUE).required(ERROR.REQUIRED),
  pageSize: yup.number().positive(ERROR.INVALID_VALUE).required(ERROR.REQUIRED),
  search: yup.string(),
  sort: yup.object().shape({
    field: yup.string().oneOf(['name', 'updatedAt', 'status', 'roomsRoles'], ERROR.INVALID_VALUE),
    direction: yup.string().oneOf(['asc', 'desc'], ERROR.INVALID_VALUE),
  }),
} as ValidationShape<PaginateParams>);

export const paginate = endpoint<PaginateParams, PaginateResult, PaginateError>({
  method: 'POST',
  url: () => '/user/paginate',
});
